import { createReducer, on } from "@ngrx/store";
import * as shelterActions from "./shelter.actions";
import * as _ from "lodash";
import { BrandingResponse } from "../../models/branding.interface";
import { Logo } from "../../models/logo.interface";
import { initialSelectedVariables } from "../selected-variables/selected-variables.reducer";

export interface ShelterExtendedModel {
  shelter: BrandingResponse;
  logos: Logo[];
}

export interface SheltersExtendedStateModel {
  initialState: boolean,
  success: boolean,
  errorCode: string,
  errorMessage: string
  shelters: ShelterExtendedModel[]
}

export const sheltersInitialStateExtended: SheltersExtendedStateModel = {
  initialState: true,
  success: true,
  errorCode: '',
  errorMessage: '',
  shelters: []
};

export const sheltersExtendedReducer = createReducer(
  sheltersInitialStateExtended,
  on(shelterActions.loadSheltersExtended, (state) => state),
  on(shelterActions.getSheltersError, (state, { errorCode, errorMessage }) => ({
    ..._.cloneDeep(state),
    initialState: false,
    success: false,
    errorCode,
    errorMessage
  })),
  on(shelterActions.getSheltersExtended, (state, { shelters }) => ({
    ..._.cloneDeep(state),
    initialState: false,
    success: true,
    errorCode: '',
    errorMessage: '',
    shelters
  })),
  on(shelterActions.resetSheltersExtended, () => ({
    ...sheltersInitialStateExtended
  }))
);
